export const payload = {
  receiveMutation: 'RECEIVE_BILLABLEITEM',
  receivingMutation: 'RECEIVING_BILLABLEITEM',
  receiveMetadataMutation: 'RECEIVE_BILLABLEITEM_METADATA',
  savingMutation: 'SAVING_BILLABLEITEM',
  updatingMutation: 'UPDATING_BILLABLEITEM',
  deleteMutation: 'DELETE_BILLABLEITEM',
  deletingMutation: 'DELETING_BILLABLEITEM',
  incrementMutation: 'INCREMENT_BILLABLEITEM_COUNT',
  resetMetaMutation: 'RESET_BILLABLEITEM_META',
  clearMutation: 'CLEAR_BILLABLEITEM_STATE',
  moduleName: 'billableitem',
  endpoint: 'billableitems',
  defaultModelGetter: 'getDefaultBillableitem',
  searchableFields: ['code', 'name', 'description']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Billableitems/actionPayload.js